import { Prisma } from "@prisma/client";

import { prisma } from "@/lib/prisma";

export async function getCommunitiesByApplicationId(applicationId: string) {
  return await prisma.applicantCommunity.findMany({
    where: {
      applicant: {
        Application: {
          every: {
            id: applicationId,
          },
        },
      },
    },
    orderBy: { sortOrder: Prisma.SortOrder.asc },
  });
}
